import { AccountTierBadge, P2GStack, P2GText } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

export type SubscriptionBoostBadgeProps = {
  dataTestId?: string;
};

export function SubscriptionBoostBadge({ dataTestId }: SubscriptionBoostBadgeProps) {
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);

  return (
    <P2GStack direction="row" alignItems="center" gap={0.5} dataTestId={dataTestId}>
      <AccountTierBadge variant="pro" size={12} />
      <P2GText variant="body2">
        {t('SUBSCRIPTION_BOOST_BADGE', { defaultValue: 'Boosted by your subscription' })}
      </P2GText>
    </P2GStack>
  );
}

export default SubscriptionBoostBadge;
